export default class StatUtils {

    constructor() {
        this.skipProducts = [];
    }

    /**
     * Get all product from page
     */
    buildCategoryItems() {
        let self = this,
            res = [];
        let $products = $('[data-st-category-wrap] [data-st-item]');
        $products.each(function () {
            if(!self.skipProducts.includes($(this).attr('data-st-id'))) {
                res.push({
                    'name': $(this).attr('data-st-name'),
                    'id': $(this).attr('data-st-id'),
                    'price': $(this).attr('data-st-price'),
                    'brand': $(this).attr('data-st-brand'),
                    'category': $(this).attr('data-st-category'),
                    'list': $(this).attr('data-st-list-name'),
                    'position': res.length + 1
                });

                self.skipProducts.push($(this).attr('data-st-id'));
            }
        });

        return res;
    }

    /**
     * Get all items from checkout
     * @returns {[]}
     */
    buildCheckoutItems() {
        let res = [];
        let $products = $('[data-st-checkout-wrap] [data-st-item]');
        $products.each(function () {
            res.push({
                'name': $(this).attr('data-st-name'),
                'id': $(this).attr('data-st-id'),
                'price': $(this).attr('data-st-price'),
                'brand': $(this).attr('data-st-brand'),
                'category': $(this).attr('data-st-category'),
                'quantity': $(this).attr('data-st-quantity'),
            })
        });
        return res;
    }
}
